import React from 'react';
import { Box, Button, VStack, Text, HStack, useColorModeValue, Divider, Tooltip } from "@chakra-ui/react";
import { Link, useLocation } from 'react-router-dom';
import { FaRegCalendarAlt, FaUserFriends, FaUniversity, FaClipboardList } from "react-icons/fa";
import PrivateSidebarLayout from '../Common/PrivateSidebarLayout';
import { useTenant } from "../Routers/TenantContextProvider";
import { usePlatformSidebar } from "../Common/PrivateSidebarContext";

const TutorSideBar = () => {
  const { tenant } = useTenant();
  const { isCollapsed } = usePlatformSidebar();
  const location = useLocation();

  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const renderNavLink = (to: string, label: string, icon: React.ReactElement) => {
    const isActive = location.pathname === to;

    const button = (
      <Button
        as={Link}
        to={to}
        justifyContent={isCollapsed ? "center" : "flex-start"}
        variant="ghost"
        size="sm"
        pl={isCollapsed ? 0 : 4}
        py={5}
        borderRadius="lg"
        bg={isActive ? hoverBg : "transparent"}
        _hover={{ bg: hoverBg }}
        fontWeight={isActive ? "semibold" : "medium"}
        w="100%"
      >
        <HStack spacing={isCollapsed ? 0 : 3}>
          {icon}
          {!isCollapsed && <Text fontSize="sm">{label}</Text>}
        </HStack>
      </Button>
    );

    return isCollapsed ? (
      <Tooltip label={label} placement="right" hasArrow>
        {button}
      </Tooltip>
    ) : button;
  };

  return (
    <PrivateSidebarLayout>
      <Box px={isCollapsed ? 1 : 3} py={4} mt={10}>
        <VStack align="stretch" spacing={1}>
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tutor-calendar`, "My Calendar", <FaRegCalendarAlt />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tutor-batches`, "Batch Management", <FaUserFriends />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tutor-upcoming-classes`, "Upcoming Classes", <FaUniversity />)}
          <Divider my={1} />
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/tutor-exams`, "Exams in Scoring", <FaClipboardList />)}
        </VStack>
      </Box>
    </PrivateSidebarLayout>
  );
};

export default TutorSideBar;